module.exports = __webpack_public_path__ + "static/img/blog_2.68321b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/blog/blog_2.jpg
// module id = C2s0
// module chunks = 1